import { EntityTypesAP214Count } from "./AP214E3_2010_gen/entity_types_ap214.gen.js";
import StepModelBase from "../step/step_model_base.js";
import SchemaAP214 from "./AP214E3_2010_gen/schema_ap214.gen.js";
import { StepTypeIndexer } from "../step/indexing/step_type_indexer.js";
import { AP214ModelGeometry } from "./ap214_model_geometry.js";
import { AP214ModelProfile } from "./ap214_model_profile.js";
import AP214StepExternalMapping from "./ap214_step_external_mapping.js";
import { AP214MaterialCache } from "./ap214_material_cache.js";
const indexerInstance = new StepTypeIndexer(EntityTypesAP214Count);
/**
 * Represents an IFC model deserialized from step.
 */
export default class AP214StepModel extends StepModelBase {
    /**
     * Construct this model given a buffer containing the data and the parsed data index on that,
     * adding the typeIndex on top of that.
     *
     * @param buffer The buffer to values from.
     * @param elementIndex The parsed index to elements in the STEP.
     */
    constructor(buffer, elementIndex) {
        super(SchemaAP214, buffer, elementIndex);
        this.externalMappingType = AP214StepExternalMapping;
        this.geometry = new AP214ModelGeometry();
        this.materials = new AP214MaterialCache();
        this.profiles = new AP214ModelProfile();
        this.typeIndex = indexerInstance.create(elementIndex);
    }
}
